import React, { useState } from "react";
import { eduData } from "./componentData/eduData";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

export default function VerticalImageCarousel() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const length = eduData.length;
  console.log(length);

  const here = <a href ="https://static.igem.wiki/teams/4260/wiki/education/syllabus-igem-education.pdf">here</a>

  const prevSlide = () => {
    setCurrentImageIndex(
      currentImageIndex === 0 ? length - 1 : currentImageIndex - 1
    );
  };
  const nextSlide = () => {
    setCurrentImageIndex(
      currentImageIndex === length - 1 ? 0 : currentImageIndex + 1
    );
  };

  if (!Array.isArray(eduData) || eduData.length <= 0) {
    return null;
  }

  return (
    <>
      <section className="vertical-carousel">
        <FaArrowUp className="up-arrow" onClick={prevSlide} />
        <FaArrowDown className="down-arrow" onClick={nextSlide} />
        {eduData.map((item, index) => {
          
         return item.title !== "Sustainable development goals and synthetic biology" ?  (
            <div
              className={index === currentImageIndex ? "slide-active" : "slide"}
              key={index}
            >
              {index === currentImageIndex && (
                <div
                  className="vertical-carousel-container glass"
                  style={{ backgroundColor: "smokewhite", opacity: 0.8 }}
                >
                  <div className="vertical-carouselimg-title">{item.title}</div>
                  <img
                    src={item.image}
                    alt="item.title"
                    className="vertical-carousel-image"
                  />
                
                  <p className="vertical-carousel-description">
                    {item.description}
                  </p>
                </div>
              )}
            </div>
          ):<div
          className={index === currentImageIndex ? "slide-active" : "slide"}
          key={index}
        >
          {index === currentImageIndex && (
            <div
              className="vertical-carousel-container glass"
              style={{ backgroundColor: "smokewhite", opacity: 0.8 }}
            >
              <div className="vertical-carouselimg-title">{item.title}</div>
              <img
                src={item.image}
                alt="item.title"
                className="vertical-carousel-image"
              />
            
              <p className="vertical-carousel-description">
                {item.description}
               
              </p>
              {here}
            </div>
          )}
        </div>
        })}
      </section>
    
    </>
  );
}
